import { ActionContext, ActionTree } from 'vuex';
import { RootState } from '@/store';
import { Grid } from '@/models/Grid.model';
import { MessagesState } from '@/store/modules/backoffice/messages/index';
import {
  CREATE_MESSAGE,
  DELETE_MESSAGES,
  GET_MESSAGES_ALL_OFFICE_LIST,
  GET_MESSAGES_BY_CUSTOMER,
  SET_MESSAGES_ALL_OFFICE_LIST,
  SET_MESSAGES_BY_CUSTOMER,
  SET_MESSAGES_BY_CUSTOMER_ERRORS,
  SET_MESSAGES_LOADING,
  SET_OPEN_CREATE_MESSAGE_MODAL,
  SET_OPEN_CREATE_MESSAGE_MODAL_ERRORS,
  SET_OPEN_DELETE_MESSAGES_MODAL,
  UPDATE_MESSAGE,
} from '@/types/backoffice/messages.types';
import MessagesService from '@/services/backoffice.messgaes.service';
import { finalize } from 'rxjs/operators';
import { BackofficeMessageModel } from '@/models/BackofficeMessage.model';
import { eventsHub } from '@/main';
import { DeleteRemindersRequest } from '@/models/backoffice/DeleteRemindersRequest';
import { SET_ALL_OFFICES_ERRORS, SET_OPEN_DELETE_MANAGER_MODAL_ERRORS } from '@/types/customer.types';
import { Utils } from '@/globals/Utils';

export const messagesService = new MessagesService();

export const actions: ActionTree<MessagesState, RootState> = {

  [GET_MESSAGES_BY_CUSTOMER]: (
    { commit, dispatch, state, rootGetters }: ActionContext<MessagesState, RootState>,
    indexNum: number,
  ) => {
    commit(SET_MESSAGES_LOADING, true);
    messagesService.getMessagesByCustomer(indexNum)
      .pipe(
        finalize(() => commit(SET_MESSAGES_LOADING, false)),
      )
      .subscribe(
        data => {
          data.employerMessages.map(item => {
            item.toDate = Utils.YYYYMMDDToDDMMYYYY('' + item.toDate);
            item.fromDate = Utils.YYYYMMDDToDDMMYYYY('' + item.fromDate);
          });
          const messagesGrid = {
            results: data.employerMessages,
            resultCount: data.employerMessages.length || 0,
          } as Grid;
          commit(SET_MESSAGES_BY_CUSTOMER, messagesGrid);
        },
        error => commit(SET_MESSAGES_BY_CUSTOMER_ERRORS, error.messages),
      );
  },

  [GET_MESSAGES_ALL_OFFICE_LIST]: (
    { commit, dispatch, state, rootGetters }: ActionContext<MessagesState, RootState>,
    indexNum: number,
  ) => {
    messagesService.getAllOfficesByCustomer(indexNum)
      .subscribe(
        data => {
          const officesGrid = {
            results: data.offices,
            resultCount: data.offices!.length || 0,
          } as Grid;
          commit(SET_MESSAGES_ALL_OFFICE_LIST, officesGrid);
        },
        error => commit(SET_ALL_OFFICES_ERRORS, error.messages));
  },

  [CREATE_MESSAGE]: (
    { commit, dispatch, state, rootGetters }: ActionContext<MessagesState, RootState>,
    message: BackofficeMessageModel,
  ) => {
    commit(SET_MESSAGES_LOADING, true);
    messagesService.createMessage(message)
      .pipe(
        finalize(() => commit(SET_MESSAGES_LOADING, false)),
      )
      .subscribe(
        () => {
          commit(SET_OPEN_CREATE_MESSAGE_MODAL, false);
          eventsHub.$notify({
            group: 'frd',
            type: 'success',
            text: '' + eventsHub.$t('back_office.settings.messages.messageCreatedSuccessfully'),
          });
          dispatch(GET_MESSAGES_BY_CUSTOMER, message.indexNum);
        },
        error => commit(SET_OPEN_CREATE_MESSAGE_MODAL_ERRORS, error.messages),
      );
  },

  [UPDATE_MESSAGE]: (
    { commit, dispatch, state, rootGetters }: ActionContext<MessagesState, RootState>,
    message: BackofficeMessageModel,
  ) => {
    commit(SET_MESSAGES_LOADING, true);
    messagesService.updateMessage(message)
      .pipe(
        finalize(() => commit(SET_MESSAGES_LOADING, false)),
      )
      .subscribe(
        () => {
          commit(SET_OPEN_CREATE_MESSAGE_MODAL, false);
          eventsHub.$notify({
            group: 'frd',
            type: 'success',
            text: '' + eventsHub.$t('back_office.settings.messages.messageUpdatedSuccessfully'),
          });
          dispatch(GET_MESSAGES_BY_CUSTOMER, message.indexNum);
        },
        error => commit(SET_OPEN_CREATE_MESSAGE_MODAL_ERRORS, error.messages),
      );
  },

  [DELETE_MESSAGES]: (
    { commit, dispatch, state, rootGetters }: ActionContext<MessagesState, RootState>,
    deleteMessagesRequest: DeleteRemindersRequest,
  ) => {
    messagesService.deleteMessages(deleteMessagesRequest)
      .subscribe(
        data => {
          commit(SET_OPEN_DELETE_MESSAGES_MODAL, false);
          eventsHub.$notify({
            group: 'frd',
            type: 'success',
            text: '' + eventsHub.$t('back_office.settings.messages.messageRemovedSuccessfully'),
          });
          dispatch(GET_MESSAGES_BY_CUSTOMER, deleteMessagesRequest.indexNum);
        },
        error => commit(SET_OPEN_DELETE_MANAGER_MODAL_ERRORS, error.messages),
      );
  },

  // [GET_CUSTOMER_DETAILS]: (
  //   { commit, dispatch, state, rootGetters }: ActionContext<MessagesState, RootState>,
  //   indexNum: number,
  // ) => {
  //   customerService.getCustomerDetails(indexNum)
  //     .subscribe(
  //       data => {
  //         commit(SET_CUSTOMER_DETAILS, data);
  //         eventsHub.$router.push({ name: 'customer-details' });
  //       },
  //       error => commit(SET_ALL_CUSTOMERS_ERRORS, error.messages),
  //     );
  // },
  //
  // [UPDATE_CUSTOMER]: (
  //   { commit, dispatch, state, rootGetters }: ActionContext<MessagesState, RootState>,
  //   customerToUpdate: CustomerDetailsModel,
  // ) => {
  //   commit(SET_UPDATE_CUSTOMER_SETTINGS_MODAL_ERRORS, []);
  //   customerService.updateCustomer(customerToUpdate)
  //     .subscribe(
  //       () => {
  //         commit(SET_UPDATE_CUSTOMER_SETTINGS_MODAL, false);
  //         eventsHub.$notify({
  //           group: 'frd',
  //           type: 'success',
  //           text: '' + eventsHub.$t('back_office.settings.customer.customerUpdatedSuccessfully'),
  //         });
  //         dispatch(GET_CUSTOMER_DETAILS, customerToUpdate.indexNum);
  //       },
  //       error => commit(SET_UPDATE_CUSTOMER_SETTINGS_MODAL_ERRORS, error.messages),
  //     );
  // },
  //
  // [GET_ALL_OFFICES_BY_CUSTOMER]: (
  //   { commit, dispatch, state, rootGetters }: ActionContext<MessagesState, RootState>,
  //   indexNum: number,
  // ) => {
  //   customerService.getAllOfficesByCustomer(indexNum)
  //     .subscribe(
  //       data => {
  //         const officesGrid = {
  //           results: data.offices,
  //           resultCount: data.offices!.length || 0,
  //         } as Grid;
  //         commit(SET_ALL_OFFICES_BY_CUSTOMER, officesGrid);
  //       },
  //       error => commit(SET_ALL_OFFICES_ERRORS, error.messages));
  // },
  //
  // [GET_OFFICE_DETAILS]: (
  //   { commit, dispatch, state, rootGetters }: ActionContext<MessagesState, RootState>,
  //   { requestBody }: RequestPayload,
  // ) => {
  //   customerService.getOfficeDetails(requestBody.indexNum, requestBody.officeNum)
  //     .subscribe(
  //       data => {
  //         commit(SET_OFFICE_DETAILS, data);
  //         commit(SET_UPDATE_OFFICE_SETTINGS_MODAL, true);
  //         commit(SET_UPDATE_OFFICE_SETTINGS_MODAL_ERRORS, []);
  //       },
  //       error => commit(SET_ALL_CUSTOMERS_ERRORS, error.messages),
  //     );
  // },
  //
  // [UPDATE_OFFICE]: (
  //   { commit, dispatch, state, rootGetters }: ActionContext<MessagesState, RootState>,
  //   officeToUpdate: CustomerDetailsModel,
  // ) => {
  //   customerService.updateOffice(officeToUpdate)
  //     .subscribe(
  //       () => {
  //         commit(SET_UPDATE_OFFICE_SETTINGS_MODAL, false);
  //         commit(SET_OFFICE_DETAILS, {} as CustomerDetailsModel);
  //         eventsHub.$notify({
  //           group: 'frd',
  //           type: 'success',
  //           text: '' + eventsHub.$t('back_office.settings.offices.officeUpdatedSuccessfully'),
  //         });
  //         dispatch(GET_ALL_OFFICES_BY_CUSTOMER, officeToUpdate.indexNum);
  //       },
  //       error => commit(SET_UPDATE_OFFICE_SETTINGS_MODAL_ERRORS, error.messages),
  //     );
  // },
  //
  // [GET_ALL_REMINDERS_BY_CUSTOMER]: (
  //   { commit, dispatch, state, rootGetters }: ActionContext<MessagesState, RootState>,
  //   indexNum: number,
  // ) => {
  //   const remindersMock = Mock.reminders.reminderTypes;
  //   customerService.getAllRemindersByCustomer(indexNum)
  //     .subscribe(
  //       (data) => {
  //         data.reminders!.forEach((reminder: any) => {
  //           remindersMock.forEach((reminderType) => {
  //             if (reminderType.value === reminder.reminderType) {
  //               reminder.reminderTypeDesc = reminderType.description;
  //             }
  //           });
  //         });
  //         const remindersGrid = {
  //           results: data.reminders,
  //           resultCount: data.reminders!.length || 0,
  //         } as Grid;
  //         commit(SET_ALL_REMINDERS_BY_CUSTOMER, remindersGrid);
  //       },
  //       error => commit(SET_UPDATE_OFFICE_SETTINGS_MODAL_ERRORS, error.messages),
  //     );
  // },
  //
  // [CREATE_REMINDERS]: (
  //   { commit, dispatch, state, rootGetters }: ActionContext<MessagesState, RootState>,
  //   createRemindersRequest: CreateRemindersRequest,
  // ) => {
  //   customerService.createReminders(createRemindersRequest)
  //     .subscribe(
  //       (data) => {
  //         commit(SET_OPEN_CREATE_REMINDERS_MODAL, false);
  //         eventsHub.$notify({
  //           group: 'frd',
  //           type: 'success',
  //           text: '' + eventsHub.$t('back_office.settings.reminders.remindersAddedSuccessfully'),
  //         });
  //         dispatch(GET_ALL_REMINDERS_BY_CUSTOMER, state.customerDetails.indexNum);
  //       },
  //       error => commit(SET_OPEN_CREATE_REMINDERS_MODAL_ERRORS, error.messages),
  //     );
  // },
  //
  // [DELETE_REMINDERS]: (
  //   { commit, dispatch, state, rootGetters }: ActionContext<MessagesState, RootState>,
  //   deleteRemindersRequest: DeleteRemindersRequest,
  // ) => {
  //   customerService.deleteReminders(deleteRemindersRequest)
  //     .subscribe(
  //       data => {
  //         commit(SET_OPEN_CREATE_REMINDERS_MODAL, false);
  //         eventsHub.$notify({
  //           group: 'frd',
  //           type: 'success',
  //           text: '' + eventsHub.$t('back_office.settings.reminders.remindersRemovedSuccessfully'),
  //         });
  //         dispatch(GET_ALL_REMINDERS_BY_CUSTOMER, state.customerDetails.indexNum);
  //       },
  //       error => commit(SET_UPDATE_OFFICE_SETTINGS_MODAL_ERRORS, error.messages),
  //     );
  // },
  //
  // [GET_MANAGERS_BY_CUSTOMER]: (
  //   { commit, dispatch, state, rootGetters }: ActionContext<MessagesState, RootState>,
  //   indexNum: number,
  // ) => {
  //   commit(SET_MANAGERS_BY_CUSTOMER, {});
  //   customerService.getManagersByCustomer(indexNum)
  //     .pipe(
  //       pluck('managers'),
  //     )
  //     .subscribe(
  //       (data: any) => {
  //         const managers = data.map((manager) => {
  //           if (manager.empFormsPriv === 1) {
  //             manager.empFormsPrivDesc = eventsHub.$t('back_office.settings.managers.MANAGER_VIEW_ONLY');
  //           } else if (manager.empFormsPriv === 2) {
  //             manager.empFormsPrivDesc = eventsHub.$t('back_office.settings.managers.MANAGER_APPROVE');
  //           }
  //           return manager;
  //         });
  //         const managersGrid = {
  //           results: managers,
  //           resultCount: managers!.length || 0,
  //         } as Grid;
  //         commit(SET_MANAGERS_BY_CUSTOMER, managersGrid);
  //       },
  //       error => commit(SET_UPDATE_OFFICE_SETTINGS_MODAL_ERRORS, error.messages),
  //     );
  // },
  //
  // [DELETE_MANAGER]: (
  //   { commit, dispatch, state, rootGetters }: ActionContext<MessagesState, RootState>,
  //   managerToDelete: ManagerPrivilegesRequest,
  // ) => {
  //   customerService.deleteManager(managerToDelete)
  //     .subscribe(
  //       data => {
  //         commit(SET_OPEN_DELETE_MANAGER_MODAL, false);
  //         eventsHub.$notify({
  //           group: 'frd',
  //           type: 'success',
  //           text: '' + eventsHub.$t('back_office.settings.managers.managerRemovedSuccessfully'),
  //         });
  //         dispatch(GET_MANAGERS_BY_CUSTOMER, state.customerDetails.indexNum);
  //       },
  //       error => commit(SET_OPEN_DELETE_MANAGER_MODAL_ERRORS, error.messages),
  //     );
  // },
  //
  // [UPDATE_MANAGER]: (
  //   { commit, dispatch, state, rootGetters }: ActionContext<MessagesState, RootState>,
  // ) => {
  //   customerService.updateManagerPrivileges(state.managerPrivileges)
  //     .subscribe(
  //       data => {
  //         commit(SET_OPEN_UPDATE_MANAGER_MODAL, false);
  //         commit(SET_ORG_UNITS, undefined);
  //         dispatch(GET_MANAGERS_BY_CUSTOMER, state.customerDetails.indexNum);
  //         eventsHub.$notify({
  //           group: 'frd',
  //           type: 'success',
  //           text: '' + eventsHub.$t('back_office.settings.managers.managerUpdatedSuccessfully'),
  //         });
  //       },
  //       error => commit(SET_OPEN_UPDATE_MANAGER_MODAL_ERRORS, error.messages),
  //     );
  // },
  //
  // [GET_MANAGER_PRIVILEGES]: (
  //   { commit, dispatch, state, rootGetters }: ActionContext<MessagesState, RootState>,
  //   managerToUpdate: ManagerPrivilegesRequest,
  // ) => {
  //   customerService.getManagerPrivileges(managerToUpdate)
  //     .subscribe(
  //       data => {
  //         commit(SET_MANAGER_PRIVILEGES, data);
  //         commit(SET_OPEN_UPDATE_MANAGER_MODAL, true);
  //
  //         // eventsHub.$notify({
  //         //   group: 'frd',
  //         //   type: 'success',
  //         //   text: '' + eventsHub.$t('back_office.settings.managers.managerRemovedSuccessfully'),
  //         // });
  //         // dispatch(GET_MANAGERS_BY_CUSTOMER, state.customerDetails.indexNum);
  //       },
  //       error => commit(SET_OPEN_UPDATE_MANAGER_MODAL_ERRORS, error.messages),
  //     );
  // },
  //
  // [SEARCH_MANAGER]: (
  //   { commit, dispatch, state, rootGetters }: ActionContext<MessagesState, RootState>,
  //   searchManagerRequest: SearchManagerRequest,
  // ) => {
  //   customerService.searchManager(searchManagerRequest)
  //     .subscribe(
  //       (data) => {
  //         const grid: any = {
  //           results: [
  //             {
  //               indexNum: data.indexNum,
  //               officeNum: data.officeNum,
  //               officeName: data.officeName,
  //               userId: data.userId,
  //               idNumber: data.idNumber,
  //               firstName: data.firstName,
  //               lastName: data.lastName,
  //               fullName: data.fullName,
  //               numAndName: data.numAndName,
  //             },
  //           ],
  //           resultCount: 1,
  //         };
  //         commit(SET_MANAGER_TO_ADD, grid);
  //       },
  //       error => commit(SET_OPEN_ADD_MANAGER_MODAL_ERRORS, error.messages),
  //     );
  // },
  //
  // [CREATE_MANAGER]: (
  //   { commit, dispatch, state, rootGetters }: ActionContext<MessagesState, RootState>,
  //   createManagerPrivilegesModel: CreateManagerPrivilegesModel,
  // ) => {
  //   customerService.createManager(createManagerPrivilegesModel)
  //     .subscribe(
  //       data => {
  //         commit(SET_OPEN_ADD_MANAGER_MODAL, false);
  //         eventsHub.$notify({
  //           group: 'frd',
  //           type: 'success',
  //           text: '' + eventsHub.$t('back_office.settings.managers.managerAddedSuccessfully'),
  //         });
  //         dispatch(GET_MANAGERS_BY_CUSTOMER, state.customerDetails.indexNum);
  //       },
  //       error => commit(SET_OPEN_ADD_MANAGER_MODAL_ERRORS, error.messages),
  //     );
  // },
  //
  // [LIST_ORG_UNITS]: (
  //   { commit, dispatch, state, rootGetters }: ActionContext<MessagesState, RootState>,
  //   organisationUnitsRequest: OrganisationUnitsRequestModel,
  // ) => {
  //   customerService.getOrganisationUnitsList(organisationUnitsRequest)
  //     .subscribe(
  //       (data: any) => {
  //         commit(SET_ORG_UNITS, {
  //           index: organisationUnitsRequest.index,
  //           officeNum: organisationUnitsRequest.officeNum,
  //           orgUnitType: organisationUnitsRequest.orgUnitType,
  //           units: data.bodyList,
  //         });
  //       },
  //       error => {
  //         commit(SET_ORG_UNITS, undefined);
  //         commit(SET_OPEN_UPDATE_MANAGER_MODAL_ERRORS, error.messages);
  //       },
  //     );
  // },

};
